import { render, staticRenderFns } from "./MyCalendar.vue?vue&type=template&id=2077bbee"
import script from "./MyCalendar.vue?vue&type=script&lang=ts"
export * from "./MyCalendar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports